import { render, staticRenderFns } from "./passwaytypeSelecter.vue?vue&type=template&id=63cc199a&scoped=true&"
import script from "./passwaytypeSelecter.vue?vue&type=script&lang=js&"
export * from "./passwaytypeSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc199a",
  null
  
)

export default component.exports